import { render, staticRenderFns } from "./companySelect.vue?vue&type=template&id=6d4054d4&scoped=true"
import script from "./companySelect.vue?vue&type=script&lang=js"
export * from "./companySelect.vue?vue&type=script&lang=js"
import style0 from "./companySelect.vue?vue&type=style&index=0&id=6d4054d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4054d4",
  null
  
)

export default component.exports